import { gql } from "@apollo/client";
import moment from "moment";

const GET_DOCUMENTOS_VISITAS_NUEVAS = gql`
    query GetVisitasNoMedico($idEvaluacion: Int!) {
        visitasNoMedico(idEvaluacion: $idEvaluacion) {
            success,
            error,
            valorEsperado {
                idVisita,
                tipoProfesional,
                profesional,
                fechaVisita
            }
        }
    }
`;

export default GET_DOCUMENTOS_VISITAS_NUEVAS;

export const adaptDocumentoVisita = (documento) => {
  return {
    idVisita: documento?.idVisita,
    tipoProfesional: documento?.tipoProfesional,
    profesional: documento?.profesional,
    fechaVisita: moment(documento?.fechaVisita).format('DD/MM/yyyy HH:mm')
  };
};

export const adaptDocumentosVisitasNuevasArray = (documentos) => {
  return structuredClone(documentos)?.
  map((documento) => adaptDocumentoVisita(documento));
};